import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
// Shown for a ?record= deep link that resolves to nothing the viewer can open.
// Deliberately one wording for "doesn't exist", "removed" and "no access" — and
// it never echoes the id or any name — so the page cannot be used to probe
// which records exist.
export function RecordUnavailable({ testId, onDismiss }) {
    return /*#__PURE__*/ _jsxs("output", {
        "data-testid": testId,
        className: "flex items-center justify-between gap-3 rounded-md border border-border bg-muted px-4 py-3 text-sm",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium text-foreground",
                        children: "This record isn't available."
                    }),
                    ' ',
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-muted-foreground",
                        children: "It may have been removed, or you may not have access to it."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                size: "sm",
                variant: "ghost",
                onClick: onDismiss,
                children: "Dismiss"
            })
        ]
    });
}
